<div class="flex sm:flex-row justify-between flex-wrap sm:flex-nowrap gap-4" [class.flex-col]="config.mobileWrap">
  <div class="flex-[4]">
    <div class="flex flex-wrap items-center gap-2">
      <ng-content select="[slot='before-title']"></ng-content>
      <h2 class="text-lg font-semibold text-themed-900">{{ config.title }}</h2>
      <ng-content select="[slot='after-title']"></ng-content>
    </div>

    <p *ngIf="config.subtitle" class="text-sm text-themed-600">{{ config.subtitle }}</p>
  </div>

  <div class="flex justify-end sm:flex-[0] flex-grow [&:not(:has(*))]:hidden [&:has(*)]:flex-1">
    <ng-content select="[slot='end']"></ng-content>
  </div>
</div>
<ng-content></ng-content>
